(() => {
  'use strict';

  document.querySelectorAll('[data-vg4-root]').forEach((root) => {
    const dialog = root.querySelector('[data-vg4-lightbox]');
    const dialogImage = dialog?.querySelector('img');
    const close = dialog?.querySelector('[data-vg4-close]');
    if (!dialog || !dialogImage) return;

    root.querySelectorAll('[data-vg4-zoom]').forEach((button) => {
      button.addEventListener('click', () => {
        const image = button.querySelector('img');
        if (!image) return;
        dialogImage.src = image.currentSrc || image.src;
        dialogImage.alt = image.alt;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else window.open(dialogImage.src, '_blank', 'noopener');
      });
    });

    close?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });
})();
